import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const TermsAndConditions = () => {
  return (
    <Card className="shadow-md border border-gray-200">
      <CardHeader className="bg-primary/10 rounded-t-lg">
        <CardTitle className="text-primary">Terms & Conditions</CardTitle>
      </CardHeader>

      <CardContent className="space-y-6 pt-6">
        {/* ------- Section 1 ------- */}
        <div className="rounded-md border p-5 bg-muted/30 shadow-sm">
          <h2 className="font-semibold text-lg mb-3 text-primary">
            Upgradation of 3-Year Old Conventional Powerloom into Rapier
            Shuttleless Loom
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-sm text-muted-foreground">
            <li>
              The applicant should be a genuine powerloom owner/operator engaged
              in textile production.
            </li>
            <li>
              Only plain powerlooms are eligible for upgradation to rapier
              shuttleless looms under this scheme.
            </li>
            <li>
              The subsidy will be provided as per the approved rates and
              guidelines of the scheme.
            </li>
            <li>All supporting documents must be genuine and verifiable.</li>
            <li>
              The modernized looms should be operational for the minimum
              required period.
            </li>
            <li>
              The applicant should not have been blacklisted by any Government
              agency.
            </li>
            <li>
              Submission of false information may lead to cancellation and legal
              action.
            </li>
            <li>
              The decision of the sanctioning authority will be final and
              binding.
            </li>
            <li>The scheme is subject to availability of budget allocation.</li>
            <li>
              I declare that the subsidy for the components received under this
              scheme has not been received any subsidy/schemes/benefits from any
              other central or state schemes
            </li>
          </ul>
        </div>

        {/* ------- Section 2 ------- */}
        <div className="rounded-md border p-5 bg-muted/30 shadow-sm">
          <h2 className="font-semibold text-lg mb-3 text-primary">
            Purchase of New Rapier Loom / Replacement of Existing Low-Speed
            Rapier Looms
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-sm text-muted-foreground">
            <li>
              The applicant should be a genuine powerloom owner/operator engaged
              in textile production.
            </li>
            <li>
              The subsidy will be provided as per the approved scheme
              guidelines.
            </li>
            <li>All supporting documents must be genuine and verifiable.</li>
            <li>
              The modernized looms should be functional for the minimum
              stipulated period.
            </li>
            <li>The applicant should not be blacklisted by any authority.</li>
            <li>
              Submission of false information may lead to application
              cancellation.
            </li>
            <li>
              The sanctioning authority's decision will be final and binding.
            </li>
            <li>The scheme depends on budget availability.</li>
          </ul>
        </div>

        {/* ------- Section 3 ------- */}
        <div className="rounded-md border p-5 bg-muted/30 shadow-sm">
          <h2 className="font-semibold text-lg mb-3 text-primary">
            Common Facility Centre
          </h2>
          <ul className="list-disc pl-5 space-y-2 text-sm text-muted-foreground">
            <li>The information provided is true and correct.</li>
            <li>Subsidy availed will only be used for eligible machinery.</li>
            <li>
              Applicants must not have availed subsidy for the same purpose
              under any other Government scheme.
            </li>
            <li>
              Units availing subsidy under this scheme are not eligible for
              Powerloom Modernisation Scheme subsidy.
            </li>
            <li>Any variation found will result in withdrawal of benefits.</li>
            <li>
              The applicant is responsible for misrepresentation or omissions.
            </li>
            <li>Purchased machinery should not be sold within 10 years.</li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};

export default TermsAndConditions;
